<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div class="overflow-hidden rounded main-height">
      <div class="flex justify-between">
        <!-- 削除ボタン -->
        <div v-if="isEdit" class="ml-1 mb-3 mt-1">
          <PrimaryButton text="削除" size="sm red-color text-white font-bold rounded px-3 py-2 hover:bg-red-800" class="" @click="deleteAll()" />
        </div>
      </div>
      <!-- 会社名 -->
      <div class="text-xs font-bold mt-auto text-gray-700">会社名</div>
      <input 
        type="text"
        class="cursor-text border-gray-300 rounded w-full py-1 focus:ring-indigo-500 focus:border-indigo-500 mb-3 text-sm"
        v-model="val.company"
      />

      <!-- お客様担当者 -->
      <div class="text-xs font-bold mt-auto text-gray-700">お客様 ご担当者名</div>
      <input 
        type="text"
        class="cursor-text border-gray-300 rounded w-full py-1 focus:ring-indigo-500 focus:border-indigo-500 mb-3 text-sm"
        v-model="val.name"
      />

      <!-- メールアドレス -->
      <div class="text-xs font-bold mt-auto text-gray-700">メールアドレス</div>
      <input 
        type="email"
        class="cursor-text border-gray-300 rounded w-full py-1 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
        v-model="val.mail"
      />
      <div class="mt-3 mx-2 mb-1 min-w-500px">
        <PrimaryButton text="保存" size="normal w-full " @click="save()" />
      </div>
    </div>
    <div class="hidden">{{reload}}</div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'
export default {
  components: {
    Modal,
    PrimaryButton,
  },

  props: ['open', 'target', 'newData'],

  data() {
    return {
      reload: 0,
      // 編集データ
      val: { company: '' },
      // 編集か否か
      isEdit: false,
      // ローディング
      loading: false,
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    /**
     * 編集対象データ取得
     */
    async getData() {
      this.loading = true
      this.val = { company: '' }
      // 編集対象データがある場合
      if (this.target) {
        this.isEdit = true
        this.val = this.target
      } else {
        this.isEdit = false
        if (this.newData) {
          this.val.mail = this.newData
        }
      }
      this.loading = false
    },

    /**
     * データ削除
     */
    async deleteAll() {
      let resDlog = await dialogs.showConfirmDialog('削除', '削除してよろしいでしょうか？')
      if (resDlog != 'YES') {
        return
      }

      await backend.deleteData('mail/deleteData', this.val)
      logManager.recording(this, logManager.Loglevel.INFO, '協力会社メールマスタ', '削除', `アドレス（${this.val.mail}）を削除しました。`)
      this.closed()
      this.$emit('close')
    },

    /**
     * 入力チェック
     */
    async validate() {
      if (!this.val.mail) {
        await dialogs.showErrorDialog('メールアドレス', 'メールアドレスを入力してください。')
        return false
      }

      let list = []
      const res = await backend.searchData('mail/getData', { type: 2 })
      if (res.data.data) {
        list = res.data.data
      }

      for (let i = 0; i < list.length; i++) {
        const o = list[i]
        if (o.mail == this.val.mail) {
          const log = await dialogs.showConfirmDialog('メールアドレス重複 確認', '既に同じメールアドレスが登録されていますが、よろしいですか？')
          if (log != 'YES') {
            return false
          } else {
            break
          }
        }
      }

      const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
      if (!reg.test(this.val.mail)) {
          await dialogs.showErrorDialog('メールアドレス不正', `メールアドレスが不正です。`)
          return false
      }
      return true
    },

    /**
     * 保存イベント
     */
    async save() {
      if (!await this.validate()) {
        return
      }
      const param = {
        type: 2,
        userId: this.$store.getters.user.id,
        userName: utils.deleteKana(this.$store.getters.user.user_name),
        ...this.val,
      }
      await backend.postData('mail/save', param)

      this.closed()
      this.$emit('close')
    },

    /**
     * 初期化
     */
    closed() {
      // 編集データ
      this.val = { company: '' },
      // 編集か否か
      this.isEdit = false
      // ローディング
      this.loading = false
    }
  }
}
</script>
<style scoped>
.main-height {
  max-height: calc(100% - 200px);
}

.min-300 {
  min-width: 300px;
}

.red-color {
  background: #c94242;
}

@media screen and (max-width: 1200px) {
  .main {
      overflow: auto;
  }
}
</style>